// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { enableProdMode, Injectable } from "@angular/core";

/*export const environment = {
  production: false,
  appName: require('../../package.json').name,
  version: require('../../package.json').version,

  apiRootUrl: 'http://localhost:5000',

  defaultDNS: 'localhost',
  defaultLogin: '',
  defaultPassword: ''

};*/

export enum Environment {
  Local = 'local',
  TestBEP = 'test-bep',
  TestIdelux = 'test-idelux',
  TestTibi = 'test-tibi',
  TestInBW = 'test-inbw',
  TestIntradel = 'test-intradel',
  ProdBEP = 'prod-bep',
  ProdIdelux = 'prod-idelux',
  ProdTibi = 'prod-tibi',
  ProdInBW = 'prod-inbw',
  ProdIntradel = 'prod-intradel',
  BetaThelis = 'beta-thelis'
}

@Injectable({ providedIn: 'root' })
export class EnvService {

  static getApiURL(): string {
    const hostname = window && window.location && window.location.hostname;
    let apiUrl;
    if (/^.*localhost.*/.test(hostname)) {
      apiUrl = 'http://localhost:5000';
    } else if (/^bep-test.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://bep-api-test.recyparcs.be';
    } else if (/^idelux-test.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://idelux-api-test.recyparcs.be';
    } else if (/^tibi-test.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://tibi-api-test.recyparcs.be';
    } else if (/^inbw-test.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://inbw-api-test.recyparcs.be';
    } else if (/^intradel-test.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://intradel-api-test.recyparcs.be';
    } else if (/^bep.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://bep-api.recyparcs.be';
    } else if (/^idelux.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://idelux-api.recyparcs.be';
    } else if (/^tibi.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://tibi-api.recyparcs.be';
    } else if (/^inbw.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://inbw-api.recyparcs.be';
    } else if (/^intradel.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://intradel-api.recyparcs.be';
    } else if (/^thelis-beta.recyparcs.be/.test(hostname)) {
      apiUrl = 'https://thelis-api-beta.recyparcs.be';
    } else {
      console.warn(`Cannot find environment for host name ${hostname}`);
    }

    return apiUrl;
  }

  static isProd(): boolean {
    const hostname = window && window.location && window.location.hostname;
    return /^bep.recyparcs.be/.test(hostname) || /^idelux.recyparcs.be/.test(hostname) || /^tibi.recyparcs.be/.test(hostname) || /^inbw.recyparcs.be/.test(hostname) || /^intradel.recyparcs.be/.test(hostname);
  }

  private _env: Environment;
  private _apiUrl: string;
  private _defaultDNS: string;
  private _defaultLogin: string;
  private _defaultPassword: string;
  private _appName: string;
  private _version: string;

  get env(): Environment {
    return this._env;
  }

  get apiUrl(): string {
    return this._apiUrl;
  }

  get defaultDNS(): string {
    return this._defaultDNS;
  }

  get defaultLogin(): string {
    return this._defaultLogin;
  }

  get defaultPassword(): string {
    return this._defaultPassword;
  }

  get appName(): Environment {
    return require('../../package.json').name;
  }

  get version(): string {
    return require('../../package.json').version;
  }

  constructor() {}

  init(): Promise<string> {
    return new Promise(resolve => {
      this.setEnvVariables();
      resolve(this.apiUrl);
    });
  }

  private setEnvVariables(): string {
    const hostname = window && window.location && window.location.hostname;
    if (/^.*localhost.*/.test(hostname)) {
      this._env = Environment.Local;
      this._apiUrl = 'http://localhost:5000';
      this._defaultDNS = 'localhost';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^bep-test.recyparcs.be/.test(hostname)) {
      this._env = Environment.TestBEP;
      this._apiUrl = 'https://bep-api-test.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^idelux-test.recyparcs.be/.test(hostname)) {
      this._env = Environment.TestIdelux;
      this._apiUrl = 'https://idelux-api-test.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^tibi-test.recyparcs.be/.test(hostname)) {
      this._env = Environment.TestTibi;
      this._apiUrl = 'https://tibi-api-test.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^inbw-test.recyparcs.be/.test(hostname)) {
      this._env = Environment.TestInBW;
      this._apiUrl = 'https://inbw-api-test.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^intradel-test.recyparcs.be/.test(hostname)) {
      this._env = Environment.TestIntradel;
      this._apiUrl = 'https://intradel-api-test.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else if (/^bep.recyparcs.be/.test(hostname)) {
      this._env = Environment.ProdBEP;
      this._apiUrl = 'https://bep-api.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
      // enableProdMode();
    } else if (/^idelux.recyparcs.be/.test(hostname)) {
      this._env = Environment.ProdIdelux;
      this._apiUrl = 'https://idelux-api.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
      // enableProdMode();
    } else if (/^tibi.recyparcs.be/.test(hostname)) {
      this._env = Environment.ProdTibi;
      this._apiUrl = 'https://tibi-api.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
      // enableProdMode();
    } else if (/^inbw.recyparcs.be/.test(hostname)) {
      this._env = Environment.ProdInBW;
      this._apiUrl = 'https://inbw-api.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
      // enableProdMode();
    } else if (/^intradel.recyparcs.be/.test(hostname)) {
      this._env = Environment.ProdIntradel;
      this._apiUrl = 'https://intradel-api.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
      // enableProdMode();
    } else if (/^thelis-beta.recyparcs.be/.test(hostname)) {
      this._env = Environment.BetaThelis;
      this._apiUrl = 'https://thelis-api-beta.recyparcs.be';
      this._defaultDNS = '';
      this._defaultLogin = '';
      this._defaultPassword = '';
    } else {
      console.warn(`Cannot find environment for host name ${hostname}`);
    }
    return this._apiUrl;
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
